// extracted by mini-css-extract-plugin
export default {"greyAlert":"Invoice3rdParty_greyAlert__p+i8s","greenAlert":"Invoice3rdParty_greenAlert__Kf7Za"};